import React, { useRef } from 'react';

import RestrictedContainer from 'components/RestrictedContainer';
import Footer from 'components/Footer/Footer';
import HowItWorks from 'components/HowItWorks';
import LandingViewHeader from 'components/LandingViewHeader';
import './LandingView.scss';
import useIGTranslation from 'hooks/useIGTranslation';
import { IViewDataProps } from 'interfaces/gameInterfaces';
import HistoricAmount from 'components/HistoricAmount/HistoricAmount';
import useDynamicImage from 'hooks/useDynamicImage';
import { HomeFunctions } from '../homeFunctions';
import config from 'theme/config';

export interface ILandingViewProps {
  data: IViewDataProps;
}

const LandingPage = (props: ILandingViewProps) => {
  const ref = useRef<any>(null);
  const { t } = useIGTranslation();
  const fileName = HomeFunctions.getLogoName();
  const logoImage = useDynamicImage({
    name: fileName,
    fileType: 'svg'
  });
  const region = process.env.REACT_APP_REGION;
  const showTermsAndConditions = config.settings.termsAndConditionsDisplayRegions.includes(region!);

  return (
    <RestrictedContainer reference={ref}>
      <div className="landing">
        <div>
          <LandingViewHeader openDate={props.data.roundStartTime} />
          <img src={logoImage!} alt={`${fileName} game badge`} className="landing__logo" data-testid={`${fileName}-image`} />
          <HistoricAmount />
          <HowItWorks translationKeys={['how-it-works-text-1', 'how-it-works-text-2']} />
          {props.data.error ? <div className="home__error">{t(props.data.error)}</div> : <></>}
          <Footer handleHowToPlayClick={props.data.handleHowToPlayClick} tokenState={props.data.tokenState} roundStartTime={props.data.roundStartTime}></Footer>
          {showTermsAndConditions && <div className="landing__termsandconditions">{t(`tcs-significant-conditions-${region}`)}</div>}
        </div>
      </div>
    </RestrictedContainer>
  );
};

export default LandingPage;
